import type { RouteObject } from 'react-router';
import { CustomerPage } from './CustomerPage';
import { CustomerUserPage } from './CustomerUserPage';
import { DocumentPage } from './DocumentPage';
import { DossierPage } from './DossierPage';

/** Detail routes (paths without a leading slash). `subjects/:id` is `SubjectPage` in routes.tsx. */
export const ACCOUNTS_ROUTES: RouteObject[] = [
  { path: 'customers/:id', element: <CustomerPage /> },
  { path: 'customers/:id/users/:userId', element: <CustomerUserPage /> },
  { path: 'dossiers/:id', element: <DossierPage /> },
  { path: 'documents/:id', element: <DocumentPage /> },
];
